
















import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ManufacturerTabSearchModel } from '@/types';
import WorkflowDynamicForm from '@/components/workflow/WorkflowDynamicForm.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { AutomotiveHelper, ObjectHelper } from '@/mixins';

export default Vue.extend({
  name: 'ManufacturerTab',
  mixins: [AutomotiveHelper, ObjectHelper],
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('automotiveWorkflowJobStore', ['getManufacturerTab']),
    getManufacturerTabData(this: any) {
      if (!this.isNullOrEmpty(this.saleType) && this.manufacturer) {
        this.getManufacturerTab({
          queueId: this.workflowJob.queueId,
          jobId: this.workflowJob.jobId,
          saleType: this.saleType,
          manufacturer: this.manufacturer
        } as ManufacturerTabSearchModel);
      }
    }
  },
  computed: {
    ...mapGetters('workflowJobStore', ['workflowDataSourceField', 'workflowJob']),
    ...mapGetters('automotiveWorkflowJobStore', ['manufacturerTab', 'isManufacturerTabLoading'])
  },
  mounted() {
    this.getManufacturerTabData();
  },
  watch: {
    saleType(this: any) {
      this.getManufacturerTabData();
    }
  },
  components: {
    WorkflowDynamicForm,
    LoadingSpinner
  }
});
